define(["require", "exports", "tslib", "mobx", "../EntityBase", "../EntityValidationState", "../../utils/EntityUtil", "../entity/FAssetAttr", "../entity/FAssetSap", "../../store/UserStore", "../domain", "../services", "../services/EventManager", "./FacilityAssetHistory"], function (require, exports, tslib_1, mobx_1, EntityBase_1, EntityValidationState_1, EntityUtil_1, FAssetAttr_1, FAssetSap_1, UserStore_1, domain_1, services_1, EventManager_1, FacilityAssetHistory_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.FAsset = void 0;
    class FAsset extends EntityBase_1.Entity {
        constructor(entity = null, parent = null) {
            super();
            Object.defineProperty(this, "FacilityId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FacilityIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypeId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AssetTypeIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Barcode", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "BarcodeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefNo", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RefNoError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CapDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "CapDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AcqValue", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AcqValueError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerType", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "OwnerTypeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateOwnershipPc", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StateOwnershipPcError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Status", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "StatusDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Condition", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ConditionDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Qty", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "QtyError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "RemainingLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLife", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedLifeDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserComment", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "UserCommentError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFId", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFIdError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditCreateUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDate", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditDateError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUser", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "AuditEditUserError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Shape", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFAssetAttr", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetAttrError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetSap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SelectedFAssetSap", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "FAssetSapError", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "Facility", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "TransferFLabel", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeYears", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "SuggestedRemLifeMonths", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: void 0
            });
            Object.defineProperty(this, "ChangeHistory", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: []
            });
            Object.defineProperty(this, "IsChangeHistoryLoaded", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: false
            });
            (0, mobx_1.makeObservable)(this);
            this.init(entity, parent, FAsset.ObservableFields);
        }
        onCreate(parent) {
            this.Id = (0, EntityUtil_1.id)();
            this.Facility = parent;
            this.FacilityId = parent.Id;
            this.PersistanceState = EntityBase_1.PersistanceStates.NEW_RECORD;
            this.SecurityAccessLevel = EntityBase_1.EntitySecurityAccessLevels.READ_WRITE;
            this.FAssetAttr = [];
            this.FAssetSap = [];
        }
        onRead(entity, parent) {
            this.Facility = parent;
            this.FAssetAttr = [];
            this.FAssetSap = [];
            this.merge(entity);
        }
        merge(entity) {
            let a = this;
            let b = entity;
            if (!a || !b)
                throw new Error(`${this.constructor.name}.merge() expected a and b to be defined`);
            a.ObjectId = b.ObjectId;
            a.Id = (0, EntityUtil_1.toInt)(entity.Id);
            a.FacilityId = (0, EntityUtil_1.toInt)(entity.FacilityId);
            a.AssetTypeId = (0, EntityUtil_1.toInt)(entity.AssetTypeId);
            a.Barcode = b.Barcode;
            a.RefNo = b.RefNo;
            a.CapDate = b.CapDate;
            a.AcqValue = (0, EntityUtil_1.toFloat)(entity.AcqValue);
            a.OwnerType = (0, EntityUtil_1.toInt)(entity.OwnerType);
            a.StateOwnershipPc = (0, EntityUtil_1.toFloat)(entity.StateOwnershipPc);
            a.Status = (0, EntityUtil_1.toInt)(entity.Status);
            a.StatusDate = b.StatusDate;
            a.Condition = (0, EntityUtil_1.toInt)(entity.Condition);
            a.ConditionDate = b.ConditionDate;
            a.Qty = (0, EntityUtil_1.toInt)(entity.Qty);
            a.RemainingLife = (0, EntityUtil_1.toInt)(entity.RemainingLife);
            a.SuggestedLife = (0, EntityUtil_1.toInt)(entity.SuggestedLife);
            a.SuggestedLifeDate = b.SuggestedLifeDate;
            a.UserComment = b.UserComment;
            a.TransferFId = (0, EntityUtil_1.toInt)(entity.TransferFId);
            a.AuditCreateDate = b.AuditCreateDate;
            a.AuditCreateUser = b.AuditCreateUser;
            a.AuditEditDate = b.AuditEditDate;
            a.AuditEditUser = b.AuditEditUser;
            a.FAssetAttr = this.mergeArray(a.FAssetAttr, b.FAssetAttr, FAssetAttr_1.FAssetAttr);
            a.SelectedFAssetAttr = a.SelectedFAssetAttr && a.FAssetAttr.find(x => x.Id == a.SelectedFAssetAttr.Id) ? a.SelectedFAssetAttr : null;
            a.FAssetSap = this.mergeArray(a.FAssetSap, b.FAssetSap, FAssetSap_1.FAssetSap);
            a.SelectedFAssetSap = a.SelectedFAssetSap && a.FAssetSap.find(x => x.Id == a.SelectedFAssetSap.Id) ? a.SelectedFAssetSap : null;
            a.Shape = (0, EntityUtil_1.mergePoint)(a.Shape, b.Shape);
            a.PersistanceState = b.PersistanceState;
            a.SecurityAccessLevel = b.SecurityAccessLevel;
            this.postMerge();
        }
        postMerge() {
        }
        onReady() {
            this.addChangeEventAction("AssetTypeId", this.updateAssetAttributes.bind(this));
            this.SuggestedRemLifeYears = Math.floor(this.SuggestedLife / 12);
            this.SuggestedRemLifeMonths = this.SuggestedLife % 12;
            this.addChangeEventAction("SuggestedRemLifeYears", this.onSuggestedLifeYearChange.bind(this));
            this.addChangeEventAction("SuggestedRemLifeMonths", this.onSuggestedLifeMonthChange.bind(this));
            if (this.TransferFId > 0) {
                this.TransferFLabel = "";
                let q = {};
                q.Id = this.TransferFId;
                services_1.SrmsServiceManager.Instance.Facility.findFacility(q, true).then(matches => {
                    if (matches.length == 1) {
                        let f = matches[0];
                        this.TransferFLabel = f.FacilityId + " (" + f.FacilityName + ")";
                    }
                    else {
                        console.log("Expected only 1 Facility");
                    }
                });
            }
        }
        hasChanges(recurseChildren = true) {
            let hasChanges = false;
            this.walk((entity) => {
                if (!hasChanges && recurseChildren && entity != null) {
                    hasChanges = hasChanges || entity.hasChanges();
                }
            }, { skipRoot: true });
            hasChanges = hasChanges || (this.PersistanceState != EntityBase_1.PersistanceStates.EXISTING_UNMODIFIED);
            return hasChanges;
        }
        validate(recurseChildren = true) {
            let validationState = new EntityValidationState_1.EntityValidationState(this.Id, FAsset.AliasName);
            this.reset();
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "AssetTypeId", "Asset Type Id");
                this.validateReqNumber(validationState, "OwnerType", "Owner Type");
                this.validateReqNumber(validationState, "StateOwnershipPc", "State Ownership (%)", { isPc: true });
                this.validateReqNumber(validationState, "Status", "Status");
                this.validateReqNumber(validationState, "Condition", "Condition");
            }
            return validationState;
        }
        _validate(validationState, recurseChildren = true) {
            if (this.PersistanceState != EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                if (recurseChildren) {
                    this.walk((entity) => { validationState.add(entity.validate()); }, { skipRoot: true });
                }
                this.validateReqNumber(validationState, "Id", "ID");
                this.validateReqNumber(validationState, "AssetTypeId", "Asset Type Id");
                this.validateReqNumber(validationState, "OwnerType", "Owner Type");
                this.validateReqNumber(validationState, "StateOwnershipPc", "State Ownership (%)", { precision: 2 });
                this.validateReqNumber(validationState, "Status", "Status");
                this.validateReqNumber(validationState, "Condition", "Condition");
            }
        }
        dispose() {
            this.walk((entity) => { super.dispose(); }, { leading: true });
        }
        walk(func, args = {}) {
            let { leading, skipRoot } = args;
            if (!skipRoot && leading) {
                func(this);
            }
            if (this.FAssetAttr) {
                for (let x of this.FAssetAttr) {
                    x.walk(func, { leading });
                }
            }
            if (this.FAssetSap) {
                for (let x of this.FAssetSap) {
                    x.walk(func, { leading });
                }
            }
            if (!skipRoot && !leading) {
                func(this);
            }
        }
        toJson() {
            return {
                ObjectId: this.ObjectId,
                Id: this.Id,
                FacilityId: this.FacilityId,
                AssetTypeId: this.AssetTypeId,
                Barcode: this.Barcode,
                RefNo: this.RefNo,
                CapDate: this.CapDate,
                AcqValue: this.AcqValue,
                OwnerType: this.OwnerType,
                StateOwnershipPc: this.StateOwnershipPc,
                Status: this.Status,
                StatusDate: this.StatusDate,
                Condition: this.Condition,
                ConditionDate: this.ConditionDate,
                Qty: this.Qty,
                RemainingLife: this.RemainingLife,
                SuggestedLife: this.SuggestedLife,
                SuggestedLifeDate: this.SuggestedLifeDate,
                UserComment: this.UserComment,
                TransferFId: this.TransferFId,
                AuditCreateDate: this.AuditCreateDate,
                AuditCreateUser: this.AuditCreateUser,
                AuditEditDate: this.AuditEditDate,
                AuditEditUser: this.AuditEditUser,
                FAssetAttr: this.FAssetAttr.map(x => x.toJson()),
                FAssetSap: this.FAssetSap.map(x => x.toJson()),
                Shape: this.Shape.toJSON(),
                IsGeometryModified: this.IsGeometryModified,
                PersistanceState: this.PersistanceState,
                SecurityAccessLevel: this.SecurityAccessLevel
            };
        }
        static create(f) {
            return new Promise((resolve, reject) => {
                (0, EventManager_1.notify)("Creating Asset");
                services_1.SrmsServiceManager.Instance.Facility.createFacilityAsset(f.Id, f.Shape).then(a => {
                    let x = new FAsset(a, f);
                    f.FAsset.push(x);
                    resolve(x);
                });
            });
        }
        get IsReadOnly() {
            return this.Facility.IsReadOnly || this.Status == domain_1.FAssetStatusDomain.Transferred || !(0, UserStore_1.isUserStateGovAdminOfficer)();
        }
        get ExpectedLifeDesc() {
            let remYears = Math.floor(this.RemainingLife / 12);
            let remMonths = this.RemainingLife % 12;
            if (remYears > 0) {
                if (remMonths > 0) {
                    return `${remYears}Y ${remMonths}M`;
                }
                else {
                    return `${remYears}Y`;
                }
            }
            else if (remMonths > 0) {
                return `${remMonths}M`;
            }
            else {
                return "Expired";
            }
        }
        onSuggestedLifeYearChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
            this.SuggestedLifeDate = new Date().valueOf();
        }
        onSuggestedLifeMonthChange() {
            this.SuggestedLife = (this.SuggestedRemLifeYears * 12) + this.SuggestedRemLifeMonths;
            this.SuggestedLifeDate = new Date().valueOf();
        }
        get AssetType() {
            if (this.Facility && this.Facility.AssetTypes) {
                return this.Facility.AssetTypes.find(at => at.Id == this.AssetTypeId);
            }
            else {
                return null;
            }
        }
        get TypeDesc() {
            let at = this.AssetType;
            if (at) {
                return at.AssetTypeDesc;
            }
            return "";
        }
        get ApplicableAssetAttributes() {
            let assetType = this.AssetType;
            if (this.Facility.AssetAttributeTypes) {
                return this.Facility.AssetAttributeTypes.filter(aat => {
                    return (aat.AssetGroup == assetType.AssetGroup) && (aat.AssetDesc == assetType.AssetDesc || aat.AssetDesc == null || aat.AssetDesc.trim().length == 0);
                });
            }
            else {
                return [];
            }
        }
        get UnassignedAttributeTypes() {
            return this.ApplicableAssetAttributes.filter(aa => {
                return !this.IsAttributeTypeAssigned(aa);
            });
        }
        IsAttributeTypeAssigned(type) {
            return this.FAssetAttr.findIndex((aa) => aa.AttrTypeId === type.Id) > -1;
        }
        updateAssetAttributes() {
            for (let i = this.FAssetAttr.length - 1; i >= 0; i--) {
                let attr = this.FAssetAttr[i];
                if (attr.AssetAttributeType.AssetGroup != this.AssetType.AssetGroup) {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                        this.FAssetAttr.splice(i, 1);
                    }
                    else {
                        attr.markForDeletion();
                    }
                }
                else {
                    if (attr.PersistanceState == EntityBase_1.PersistanceStates.MARKED_FOR_DELETION) {
                        attr.PersistanceState = attr.PersistanceStateBeforeDelete;
                    }
                }
            }
        }
        lazyLoadChangeHistory() {
            return new Promise((resolve, reject) => {
                if (this.PersistanceState == EntityBase_1.PersistanceStates.NEW_RECORD) {
                    this.IsChangeHistoryLoaded = true;
                }
                if (!this.IsChangeHistoryLoaded) {
                    (0, EventManager_1.notify)("Loading Change History");
                    services_1.SrmsServiceManager.Instance.Facility.getFacilityAssetChangeHistory(this.Id).then(h => {
                        h.forEach(x => this.ChangeHistory.push(new FacilityAssetHistory_1.FacilityAssetHistory(x, this)));
                        this.IsChangeHistoryLoaded = true;
                        resolve();
                    });
                }
                resolve();
            });
        }
    }
    exports.FAsset = FAsset;
    Object.defineProperty(FAsset, "Name", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "FAsset"
    });
    Object.defineProperty(FAsset, "AliasName", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Facility Asset"
    });
    Object.defineProperty(FAsset, "ObservableFields", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: ["ObjectId", "Id", "FacilityId", "AssetTypeId", "Barcode", "RefNo", "CapDate", "AcqValue", "OwnerType", "StateOwnershipPc", "Status", "StatusDate", "Condition", "ConditionDate", "Qty", "RemainingLife", "SuggestedLife", "SuggestedLifeDate", "UserComment", "TransferFId", "AuditCreateDate", "AuditCreateUser", "AuditEditDate", "AuditEditUser", "Shape"]
    });
    Object.defineProperty(FAsset, "FacilityIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AssetTypeIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "BarcodeLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAsset, "BarcodeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "RefNoLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 11
    });
    Object.defineProperty(FAsset, "RefNoReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "CapDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AcqValueReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "OwnerTypeDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "OwnerTypeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "StateOwnershipPcReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "StatusDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "StatusReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "StatusDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "ConditionDomain", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "ConditionReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: true
    });
    Object.defineProperty(FAsset, "ConditionDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "QtyTooltip", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "Quantity (leave empty if zero)"
    });
    Object.defineProperty(FAsset, "QtyReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "RemainingLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "SuggestedLifeReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "SuggestedLifeDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "UserCommentLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 2048
    });
    Object.defineProperty(FAsset, "UserCommentReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "TransferFIdReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AuditCreateDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AuditCreateUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAsset, "AuditCreateUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AuditEditDateReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    Object.defineProperty(FAsset, "AuditEditUserLength", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: 255
    });
    Object.defineProperty(FAsset, "AuditEditUserReq", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FacilityId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FacilityIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AssetTypeId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AssetTypeIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Barcode", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "BarcodeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "RefNo", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "RefNoError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "CapDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "CapDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AcqValue", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AcqValueError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "OwnerType", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "OwnerTypeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "StateOwnershipPc", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "StateOwnershipPcError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Status", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "StatusError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "StatusDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "StatusDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Condition", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "ConditionError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "ConditionDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "ConditionDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Qty", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "QtyError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "RemainingLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "RemainingLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedLife", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedLifeError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedLifeDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedLifeDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "UserComment", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "UserCommentError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "TransferFId", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "TransferFIdError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditCreateDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditCreateDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditCreateUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditCreateUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditEditDate", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditEditDateError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditEditUser", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "AuditEditUserError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Shape", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SelectedFAssetAttr", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FAssetAttrError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FAssetSap", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SelectedFAssetSap", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "FAssetSapError", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "Facility", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FAsset.prototype, "onCreate", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAsset.prototype, "onRead", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FAsset.prototype, "merge", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "TransferFLabel", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedRemLifeYears", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "SuggestedRemLifeMonths", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "IsReadOnly", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "ExpectedLifeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "AssetType", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "TypeDesc", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "ApplicableAssetAttributes", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], FAsset.prototype, "UnassignedAttributeTypes", null);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "ChangeHistory", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], FAsset.prototype, "IsChangeHistoryLoaded", void 0);
});
